// src/app/app-components/crm-modules/Column.jsx
import { useTranslation } from 'react-i18next';
// Translation is 100% done
import { Droppable } from '@hello-pangea/dnd';
import DraggableItem from './DraggableItem';
import { Button } from '../../../components/ui/button';

const Column = ({
  columnId,
  column = { column_name: '', investors: [] },
  onAddInvestor,
  boardId,
  disableDnD = false,
}) => {
  const { t } = useTranslation();
  if (!columnId) {
    return null;
  }

  const items = column.investors;
  const uniqueItems = items.filter(
    (item, index, self) => self.findIndex((investor) => investor.investor_id === item.investor_id) === index
  );

  const handleAddInvestorClick = () => {
    onAddInvestor(columnId);
  };

  return (
    <div className="flex flex-col flex-shrink-0 items-center mr-3 mt-4 w-64">
      <div className="flex items-center w-full h-8 mb-2 bg-white border border-stone-300 rounded-md px-3">
        <h2 className="text-sm font-medium text-stone-900">
          {column.column_name || 'Unnamed Column'} <span className="text-sm">({[...new Set(items.map(inv => inv.investor_id))].length})</span>
        </h2>
      </div>
      <div className="bg-stone-50 rounded-md w-full h-full" style={{ minHeight: '500px' }}>
        {columnId && !disableDnD && (
          <Droppable droppableId={String(columnId)} key={String(columnId)}>
            {(provided, snapshot) => (
              <div
                {...provided.droppableProps}
                ref={provided.innerRef}
                className={`p-2 ${snapshot.isDraggingOver ? 'bg-white' : ''}`}
                style={{
                  maxHeight: '500px', /* Set max height */
                  overflowY: 'auto', /* Add vertical scrolling */
                }}
              >
                {uniqueItems.map((item, index) => (
                    <DraggableItem
                      key={item.investor_id}
                      investor={item}
                      index={index}
                      boardId={boardId}
                      columnId={columnId}
                    />
                  ))}
                {provided.placeholder}
                <Button variant="outline" size="sm" className="w-full" onClick={handleAddInvestorClick}>
                  {t('app:crm.t13')}
                  </Button>
              </div>
            )}
          </Droppable>
        )}

        {columnId && disableDnD && (
          <div
            className="p-2"
            style={{
              maxHeight: '500px',
              overflowY: 'auto',
            }}
          >
            {uniqueItems.map((item, index) => (
              <DraggableItem
                key={item.investor_id}
                investor={item}
                index={index}
                boardId={boardId}
                columnId={columnId}
                disableDnD
              />
            ))}

            <Button variant="outline" size="sm" className="w-full" onClick={handleAddInvestorClick}>
              {t('app:crm.t13')}
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};

export default Column;
